import { render } from "./ModalController.vue?vue&type=template&id=c9c26cac"
import script from "./ModalController.vue?vue&type=script&lang=js"
export * from "./ModalController.vue?vue&type=script&lang=js"

import "./ModalController.vue?vue&type=style&index=0&id=c9c26cac&lang=scss"

import exportComponent from "../../../../../CASRA/saoil/webadmin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__